import { render, staticRenderFns } from "./StudentEducation.vue?vue&type=template&id=a2a60288"
import script from "./StudentEducation.vue?vue&type=script&lang=ts"
export * from "./StudentEducation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports